import { differenceInDays, format, isAfter, parseISO } from 'date-fns';

export class DateHelper {
	static getYearsDropdown(startYear) {
		const endYear = new Date().getFullYear();
		return Array.from(
			{ length: endYear - startYear + 1 },
			(_, i) => i + startYear
		);
	}

	static formatDate(date, dateFormat = 'MMM dd, yyyy', locale = null) {
		if (!date || date === '0001-01-01T00:00:00') {
			return '';
		}

		const parsedDate = typeof date === 'string' ? new Date(date) : date;

		if (parsedDate.getFullYear() >= 9999) {
			return '';
		}

		const options = locale ? { locale } : {};

		return format(parsedDate, dateFormat, options);
	}

	static secondsToHm(seconds) {
		const sec = Number(seconds);
		const d = Math.floor(sec / 86400);
		const h = Math.floor((sec % 86400) / 3600);
		const m = Math.floor((sec % 3600) / 60);
		const dDisplay = d > 0 ? d + 'd ' : '';
		const hDisplay = h > 0 ? h + 'h ' : '';
		const mDisplay = m > 0 ? m + 'min' : '';
		return dDisplay + hDisplay + mDisplay;
	}

	static dateIsAfter(date) {
		let dateFormat = 'yyyy-MM-dd';
		if (date) {
			let setDate = this.formatDate(date, dateFormat) || null;
			let currentDate = this.formatDate(new Date(), dateFormat) || null;
			return isAfter(parseISO(currentDate), parseISO(setDate));
		}
		return true;
	}

	static checkDateDifference(date) {
		const lastDate = parseISO(date);
		const today = new Date();

		return differenceInDays(today, lastDate);
	}
}
